import { BodyText, withStyles } from 'vopay';
import { useTranslation } from 'react-i18next';
import { useAlertDialog } from '#shared/providers/AlertDialog';
import { SettingsCardImgsMap } from './SettingsCard/SettingsCardImg';
import { SettingsItem, SettingsHostActions } from './types';
import styles from './useSettingsLockedDialog.module.scss';

const cn = withStyles(styles);

// Generic locked-feature dialog: title/description/icon come from the item the host built —
// shared owns only this shell copy (notice/button labels), never a portal's own feature catalogue.
export default function useSettingsLockedDialog(onRequestAccess: SettingsHostActions['onRequestAccess']) {
  const alertDialog = useAlertDialog();
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Settings.LockedDialog' });

  return async function showLockedFeatureDialog(item: SettingsItem) {
    const notEnabledNotice = t('notEnabledNotice', { defaultValue: 'Not enabled on your account.' });

    const result = await alertDialog.open(
      item.title,
      // The dialog sizes to its content, so cap the description or one long line widens the whole dialog.
      <BodyText className={cn('description')}>
        <strong>{notEnabledNotice}</strong> {item.lockedDescription}
      </BodyText>,
      {
        top: <img className={cn('icon')} src={SettingsCardImgsMap[item.icon].src} alt="" />,
        abortLabel: t('maybeLater', { defaultValue: 'Maybe Later' }),
        confirmLabel: t('requestAccess', { defaultValue: 'Request Access' }),
        closeButton: true,
      },
    );

    if (result === 'confirm') onRequestAccess(item);
  };
}
